var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectionHigh = function SvgConnectionHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.925 7.95H9.95a.6.6 0 0 1 .6.6v6.15a.6.6 0 0 1-.6.6H7.925a.6.6 0 0 1-.6-.6V8.55a.6.6 0 0 1 .6-.6ZM13.55 3.45h2.025a.6.6 0 0 1 .6.6V14.7a.6.6 0 0 1-.6.6H13.55a.6.6 0 0 1-.6-.6V4.05a.6.6 0 0 1 .6-.6Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.325 11.7H2.3a.6.6 0 0 0-.6.6v2.4a.6.6 0 0 0 .6.6h2.025a.6.6 0 0 0 .6-.6v-2.4a.6.6 0 0 0-.6-.6Z",
    fill: "#fff"
  })));
};
export default SvgConnectionHigh;